// extracted by mini-css-extract-plugin
export var headerCell = "_1l-1";
export var loadingSpinnerContainer = "_1l-4";
export var loadingStateCell = "_1l-5";
export var rowWrapper = "_1l-3";
export var standaloneTable = "_1l-6";
export var table = "_1l-0";
export var white = "_1l-2";